import { render, staticRenderFns } from "./BlackListEdit.vue?vue&type=template&id=257ca7e5&scoped=true"
import script from "./BlackListEdit.vue?vue&type=script&lang=js"
export * from "./BlackListEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257ca7e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('257ca7e5')) {
      api.createRecord('257ca7e5', component.options)
    } else {
      api.reload('257ca7e5', component.options)
    }
    module.hot.accept("./BlackListEdit.vue?vue&type=template&id=257ca7e5&scoped=true", function () {
      api.rerender('257ca7e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/blackList/BlackListEdit.vue"
export default component.exports